module.exports = __webpack_public_path__ + "h5-static/img/team.496ee749.png";